export const LOCALHOST_BASE_URL="https://localhost:44384"
export const DEVELOPMENT_BASE_URL="https://dev-cowi.euwest01.umbraco.io"
export const DEVELOPMENT_FOND_BASE_URL="https://subsite1.cowifonden.test.stromlin.com/"
export const STAGING_BASE_URL="https://stage-cowi.euwest01.umbraco.io"
export const STAGING_FOND_BASE_URL="https://subsite2.cowifonden.test.stromlin.com/"
export const PRODUCTION_BASE_URL="https://cowi.euwest01.umbraco.io"
export const LIVE_BASE_URL="https://www.cowi.com"
export const IIS_FOND_BASE_URL="https://local.cowifonden.dk"
export const IIS_BASE_URL="https://local.cowi.dk"
export const LIVE_FOND_BASE_URL="https://www.cowifonden.com"

export enum NavLinkType {
  DROPDOWN = "navigationDropdown",
  LINK = "navigationListItem",
}

export enum RelatedItemsType{
  NEWS= "news",
  INSIGHT = "insight",
  PROJECT = "project",
}

export enum FilterTagType{
  NEWSTAG = "newstag",
  SECTOR_TAG = "sectorTag",
  PROJECTS = "projectTag",
}

export enum ComponentType {
  CONTENT_BANNER = "contentBanner",
  CAMPAIGN_BANNER = "campaignBanner",
  LATEST_NEWS = "latestNewsComponent",
  ACCORDION_COMPONENT = "accordionComponent",
  SPOT_LIST = "spotComponent",
  RELATED_PROJECTS = "relatedProjectComponent",
  LIST_COMPONENT = "listComponent",
  CONTACT_LIST = "contactListComponent",
  RELATED_INSIGHTS = "relatedInsightsComponent",
  QUOTE = "quoteComponent",
  RICH_TEXT_COMPONENT = "richtextComponent",
  IMAGE_MODULE = "imageModuleComponent",
  DATA_COMPONENT = "dataComponent",
  EXPERT_COMPONENT = "expertComponent",
  MAP_COMPONENT = "mapComponent",
  RELATED_PAGES = "relatedPagesComponent",
  TESTIMONIAL_COMPONENT = "testimonialComponent",
  TIMELINE_COMPONENT = "timelineComponent",
  VIDEO_COMPONENT = "videoComponent",
  TABLE = "tableComponent",
  EMPLOYEES = "employeesComponent",
  REGIONAL_EXPERT_COMPONENT = "regionalExpertComponent",

}

export enum ThemeColor {
  AUBERGINE = "aubergine",
  OCEAN = "ocean",
  GRASS = "grass",
  SKY = "sky",
  SAND = "sand",
  PINK = "pink",
  MINT = "mint",
  COWIFONDGREEN = "cowifond-green",
}

export enum Alias {
  dXl = "dXl",
  dLg = "dLg",
  dMd = "dMd",
  mLg = "mLg",
  mMd = "mMd",
  mSm = "mSm",
  listXl = "listXl",
  listLg = "listXl",
  listMd = "listMd",
  mlistLg = "mlistLg",
  mlistMd = "mlistMd",
  mlistSm = "mlistSm",
}

export enum Icon{
  ARROW = "Arrow",
  FACEBOOK = "Facebook",
  INSTAGRAM = "Instagram",
  LINKEDIN = "LinkedIn",
  MAILTO = "MailTo",
  TWITTER = "Xicon",
}